import React from 'react';
import { NameCard } from './NameCard';
import { NameSuggestion } from '../../types/name';

interface NameListProps {
  suggestions: NameSuggestion[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

export const NameList: React.FC<NameListProps> = ({
  suggestions,
  selectedIndex,
  onSelect,
}) => {
  return (
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-6">
        {suggestions.map((suggestion, index) => (
          <div key={index} className="w-full flex justify-center">
            <NameCard
              suggestion={suggestion}
              isActive={index === selectedIndex}
              onClick={() => onSelect(index)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
